module.exports = __webpack_public_path__ + "static/media/Logo.60ed84d2.svg";